import { useQuery } from 'react-query';
import { listAlertRules } from '../services/alertRuleService';


export const useAlertRules = () => {
  return useQuery('alert-rules', listAlertRules, {
    staleTime: 10,
    cacheTime: 10,
    refetchOnWindowFocus: false
  });
};